<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <!-- <pxkeji-btn name="ceshi" type="primary" size="large" roles="设备新增,设备编辑"  icon="search"  />  -->

      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="名称">
              <a-input placeholder="请输入名称" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="状态">
              <a-select defaultValue v-model="where.keyword.status">
                <a-select-option value>全部</a-select-option>
                <a-select-option value="1">启用</a-select-option>
                <a-select-option value="0">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-button type="primary" @click="searchList" v-btnlimit="'广告位管理-搜索'">搜索</a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="clear">清空</a-button>
          </a-col>
        </a-row>
        <!-- <a-row>
          <a-col :span="24" :style="{ textAlign: 'right' }">
            <a-button type="primary" @click="searchList">搜索</a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="clear">清空</a-button>
            <a :style="{ marginLeft: '8px', fontSize: '12px' }" @click="toggle">
              {{ expand?"闭合":"高级搜索" }}
              <a-icon :type="expand ? 'up' : 'down'"/>
            </a>
          </a-col>
        </a-row>-->
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <pxkeji-btn
        name="添加"
        class="pxkeji_basic_btn"
        v-btnlimit="'广告位管理-添加'"
        @click="showInfo({'id':0})"
        type="primary"
      />
      <!-- <pxkeji-btn name="批量导出" v-if="selectRows.length>0" class="pxkeji_basic_btn" /> -->
      <pxkeji-btn
        name="批量启用"
        v-btnlimit="'广告位管理-批量启用'"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
        @click="batchEnable"
      />
      <pxkeji-btn
        name="批量禁用"
        v-btnlimit="'广告位管理-批量禁用'"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
        @click="batchDisEnable"
      />

      <a-alert type="info" showIcon style="margin-bottom:20px">
        <span slot="message">
          已选择 {{selectRows.length}} 项
          <a
            @click="clearRows"
            style="color: #1890ff;margin-left:10px"
          >清空</a>
        </span>
      </a-alert>

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="status" slot-scope="status">
          <a-tag v-if="status" color="green">已启用</a-tag>
          <a-tag v-else color="red">已禁用</a-tag>
        </span>
        <span slot="action" slot-scope="action">
          <pxkeji-btn name="编辑" @click="showInfo(action)" size="small" type="primary" v-btnlimit="'广告位管理-编辑'"/>
          <a-divider type="vertical" />
          <!-- <pxkeji-btn
            name="禁用"
            @click="handleStatus(action.id,0)"
            size="small"
            type="dashed"
            v-if="action.status==1"
          />
          <pxkeji-btn
            name="启用"
            @click="handleStatus(action.id,1)"
            size="small"
            type="dashed"
            v-else
          /> -->

          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="1">
                <pxkeji-btn
                  name="禁用"
                  v-btnlimit="'广告位管理-启用禁用'"
                  @click="handleStatus(action.id,0)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                  v-if="action.status==1"
                />
                <pxkeji-btn
                  name="启用"
                  v-btnlimit="'广告位管理-启用禁用'"
                  @click="handleStatus(action.id,1)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                  v-else
                />
              </a-menu-item>
              <a-menu-item key="2">
                <pxkeji-btn
                  name="删除"
                  v-btnlimit="'广告位管理-删除'"
                  @click="delInfo(action.id)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
            </a-menu>
            <a-button size="small" type="dashed" v-btnlimit="'广告位管理-更多'">
              更多
              <a-icon type="down" />
            </a-button>
          </a-dropdown>



        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>共有：{{list.pagination.total}}条数据</span>
        </div>
      </div>
    </div>

    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      width="60%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :infos="addedit.info" />
    </a-modal>
  </div>
</template>
<script>
var that;
import Info from "./advertzoneInfo.vue"; //新增编辑

const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "广告位编号"
  },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "广告位名称"
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  name: "advertzonelist",
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          status: ""
        }
      },
      selectRows: [], //选中项编号
      isloading: false,
      visible: false //弹框
    };
  },
  components: {
    Info: Info
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    toggle() {
      this.expand = !this.expand;
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      this.$api.adzone
        .pageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.name,
          this.where.keyword.status
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onTimeChange(date, dateString) {
      this.where.keyword.startTime = dateString[0];
      this.where.keyword.endTime = dateString[1];
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    showInfo(info) {
      //打开弹出框

      this.addedit.visible = true;
      this.addedit.title = info.id ? "编辑" : "新增";
      this.addedit.info = info;
    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      this.$confirm({
        title: "您确定要执行批量禁用的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.handleProhibit(that.selectRows.join(","), 0);
        },
        onCancel() {}
      });
    },
    /**单个启用禁用 */
    handleStatus(ids, status) {
      if (status == 0) {
        this.$confirm({
          title: "您确定要执行禁用的操作吗?",
          okText: "确定",
          okType: "danger",
          cancelText: "我再想想",
          onOk() {
            that.handleProhibit(ids, 0);
          },
          onCancel() {}
        });
      } else {
        that.handleProhibit(ids, 1);
      }
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      that.isloading = true;
      that.$api.adzone
        .chanageStatus(status,ids)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.adzone
            .del(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },

    save() {
      this.addedit.visible = false;
      this.GetList();
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

